import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { AtSign } from 'lucide-react';
import { adminApi, apiError } from '../portal/api';
import { ErrorBox } from '../portal/ui';

const input = 'w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1E3A8A]/40';
const btn = 'px-4 py-2 rounded-xl bg-[#1E3A8A] text-white text-sm font-bold disabled:opacity-50';

export const ChangeEmailModal = ({ account, onClose, onDone }) => {
  const [email, setEmail] = useState('');
  const [sendEmail, setSendEmail] = useState(true);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr(''); setBusy(true);
    try { const { data } = await adminApi.patch(`/api/portal-admin/accounts/${account.id}/email`, { email, send_email: sendEmail }); onDone(data); onClose(); }
    catch (e2) { setErr(apiError(e2)); } finally { setBusy(false); }
  };
  return createPortal(
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
      <form onSubmit={submit} className="portal-card rounded-2xl bg-white p-6 w-full max-w-md space-y-3" onClick={(e) => e.stopPropagation()} data-testid="change-email-modal">
        <h3 className="font-bold text-lg flex items-center gap-2"><AtSign className="h-5 w-5 text-[#1E3A8A]" />Change login email</h3>
        <p className="text-sm text-slate-600">Current login: <b className="break-all">{account.email}</b>. The customer will sign in with the new address; the password stays the same and all active sessions are signed out.</p>
        <input className={input} type="email" required autoFocus placeholder="New login email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="change-email-input" />
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={sendEmail} onChange={(e) => setSendEmail(e.target.checked)} data-testid="change-email-notify" />Notify old and new address (from notification@)</label>
        <ErrorBox message={err} testId="change-email-error" />
        <div className="flex gap-2 justify-end"><button type="button" onClick={onClose} className="px-4 py-2 rounded-xl border text-sm" data-testid="change-email-cancel">Cancel</button><button type="submit" disabled={busy || !email} className={btn} data-testid="change-email-confirm">{busy ? 'Saving…' : 'Change email'}</button></div>
      </form>
    </div>
  , document.body);
};
